export default __webpack_public_path__ + "static/media/instagram-hero.dceb2d39.svg";